import { render, staticRenderFns } from "./KnProductContainer.vue?vue&type=template&id=4f533048&"
import script from "./KnProductContainer.vue?vue&type=script&lang=js&"
export * from "./KnProductContainer.vue?vue&type=script&lang=js&"
import style0 from "./KnProductContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports